import { __read, __spreadArray } from "tslib";
import { Observable } from '../Observable';
import { arrayOrObject } from '../util/argsArgArrayOrObject';
import { identity } from '../util/identity';
import { createObject } from '../util/createObject';
import { createOperatorSubscriber } from '../operators/OperatorSubscriber';
import { EMPTY } from './empty';
import { from } from './from';
export function combineLatest(sources, resultSelector) {
    var parts = arrayOrObject(sources);
    if (!parts) {
        throw new TypeError('sources must be an array or object');
    }
    var observables = parts.args, keys = parts.keys;
    if (observables.length === 0) {
        return EMPTY;
    }
    return new Observable(combineLatestInit(observables, keys
        ? function (values) { return createObject(keys, values); }
        : resultSelector
            ? function (values) { return resultSelector.apply(void 0, __spreadArray([], __read(values), false)); }
            : identity));
}
export function combineLatestInit(observables, valueTransform) {
    if (valueTransform === void 0) { valueTransform = identity; }
    return function (subscriber) {
        var length = observables.length;
        var values = new Array(length);
        var active = length;
        var remainingFirstValues = length;
        var _loop_1 = function (i) {
            var source = from(observables[i]);
            var hasFirstValue = false;
            source.subscribe(createOperatorSubscriber(subscriber, function (value) {
                values[i] = value;
                if (!hasFirstValue) {
                    hasFirstValue = true;
                    remainingFirstValues--;
                }
                if (!remainingFirstValues) {
                    subscriber.next(valueTransform(Array.from(values)));
                }
            }, function () {
                if (!--active) {
                    subscriber.complete();
                }
            }));
        };
        for (var i = 0; i < length; i++) {
            _loop_1(i);
        }
    };
}
//# sourceMappingURL=combineLatest.js.map